export default {
  setProperty(state, { property, payload }) {
    state[property] = payload;
  },

  setNewSupply(state, { payload }) {
    state.supplies = [...state.supplies, ...[payload]];
  },

  delProperty(state, { property }) {
    state.supplies = state.supplies.filter(el => el.id !== property);
  },

  setNewSuppliedGood(state, { payload }) {
    state.supply.goods = [...state.supply.goods, ...[payload]];
  },

  setSuppliedGood(state, { property, payload }) {
    state[property] = payload;
  },

  delSuppliedGood(state, { property }) {
    state.supply.goods = state.supply.goods.filter(el => el.id !== property);
  },
};
